{
  "paymentMethod": {
    "BANK_CARD": "Thẻ ngân hàng",
    "ALIPAY": "Alipay",
    "WECHAT": "WeChat"
  },
  "flatFee": "Mỗi giao dịch {{amount}}",
  "vipConditionsTitle": "Điều kiện giao dịch nhanh VIP {{level}}",
  "noVipPaymentMethods": "Cấp VIP hiện tại không có phương thức thanh toán giao dịch nhanh khả dụng",
  "fee": "Phí {{value}}",
  "availableRange": "Phạm vi khả dụng {{value}}",
  "checkout": "Thanh toán {{method}}",
  "close": "Đóng",
  "checkoutLoading": "Đang tải trang thanh toán…",
  "checkoutLoadFailed": "Không thể tải trang thanh toán tạm thời. Vui lòng thử lại.",
  "retry": "Thử lại",
  "checkoutHint": "Hãy hoàn tất thanh toán {{method}} trên trang này. Hệ thống sẽ tự xác nhận khi tiền đến.",
  "openCheckout": "Mở trang thanh toán",
  "externalCheckoutHint": "Mở cửa sổ mới để hoàn tất thanh toán {{method}}. Hệ thống sẽ tự xác nhận khi tiền đến. Bạn có thể quay lại đây để mở lại trang thanh toán hoặc chọn phương thức khác.",
  "externalCheckoutUnavailableHint": "Nếu không thể mở hoặc tải trang thanh toán, hãy quay lại đây để chọn phương thức thanh toán khác.",
  "chooseOtherMethod": "Chọn phương thức thanh toán khác",
  "chooseOtherMethodHint": "Chỉ chọn phương thức khác nếu bạn chưa thanh toán. Đơn này vẫn còn hiệu lực đến khi nhận tiền hoặc hết hạn."
}
